import 'react-multi-carousel/lib/styles.css';
import './MultiSlider3.css';

import { AndimarTitle } from '../Title/AndimarTitle';
import Carousel from 'react-multi-carousel';
import MultiSlideType1 from './MultiSlideType1';
import React from 'react';
import getIcons from '../../functions/getIcons/getIcons';

const removeArrowOnDeviceType = ['tablet', 'mobile', 'desktop'];

const MultiSlider3 = props => {
	const responsive = {
		superLargeDesktop: {
			// the naming can be any, depends on you.
			breakpoint: { max: 4000, min: 3000 },
			items: props.noOfSlidesInSuperLargeDesktop || 4,
		},
		desktop: {
			breakpoint: { max: 3000, min: 1024 },
			items: props.noOfSlidesInDesktop || 3,
		},
		tablet: {
			breakpoint: { max: 1024, min: 464 },
			items: 2,
		},
		mobile: {
			breakpoint: { max: 464, min: 0 },
			items: 1,
		},
	};

	const name = props.operator && props.operator.operator_name;
	console.log('name', name);

	const getArrowColor = () => {
		if (name === 'andimar') {
			return '#161d4f';
		}

		if (name === 'sanantonio') {
			return '#E66211';
		}

		if (name === 'liquine') {
			return '#4ba41c';
		}

		if (name === 'pullmandelsur') {
		return '#ff7d00';
		}
		if (name === 'busnorte') {
		return '#035f2e';
		}
		if (name === 'aeroquinta') {
		return '#232841';
		}
		if (name === 'tacoha') {
			return '#161b4f';
		}

		if (name === 'pullmandelsur') {
			return '#ff7d00';
		}
		if (name === 'busnorte') {
			return '#035f2e';
		}
		if (name === 'chilebus') {
			return '#000';
		}
	};

	return (
		<div
			className="multi-slider-container-outer"
		// style={{ marginLeft: name == 'traveltur' ? '200px' : 0 }}
		>
			{props.andrimarArrowStyle && <style>head</style>}

			<style>
				.react-multiple-carousel__arrow {'{'}
				background-color: transparent;
				{'}'}
				.react-multiple-carousel__arrow:before {'{'}
				color: {getArrowColor()};{'}'}
				.react-multiple-carousel__arrow:hover {'{'}
				background-color: transparent;
				{'}'}
				.react-multiple-carousel__arrow--right{'{'}
				right: -13px;
				{'}'}
				.react-multiple-carousel__arrow--left {'{'}
				background-color: transparent; left: -13px;
				{'}'}
			</style>

			{/* <AndimarTitle title={'NUESTROS DESTINOS FAVORITOS'} /> */}
			<div className="multi-slider-container">
				<Carousel
					responsive={responsive}
					swipeable={true}
					draggable={false}
					showDots={false}
					infinite={true}
					autoPlay={true}
					autoPlaySpeed={3000}
					customTransition="1s"
					transitionDuration={3000}
					removeArrowOnDeviceType={
						props.removeArrowOnDeviceType ? props.removeArrowOnDeviceType : removeArrowOnDeviceType
					}
				>
					{props.multiSlides &&
						(props.multiSlides.length || []) > 0 &&
						props.multiSlides.map((slide, index) => {
							return props.slideType === 1 ? (
								<div className="">
									<MultiSlideType1 slide={slide} itemNo={index} />
								</div>
							) : (
								<div style={{ margin: '0 20px' }}>
									{props.textCard ? (
										<MultiSlideType1 slide={slide.image} itemNo={index} />
									) : (
										<MultiSlideType1 slide={slide} itemNo={index} />
									)}
									{props.textCard && (
										<div
											style={{
												background: props.operator && props.operator.operator_name === "busnorte" ? props.operator.color_codes.header_color : "#F3F7FF",
												padding: 15,
												borderBottomLeftRadius: 10,
												borderBottomRightRadius: 10,
												minHeight: props.minHeightCard ? props.minHeightCard : '275px',
												display: 'flex',
												flexDirection: 'column',
												alignItems: 'space-between',
												justifyContent: 'space-between',
												color: props.operator && props.operator.operator_name === "busnorte" ? "white" : "black"
											}}
										>
											<div style={{ minHeight: 140, }}>
												{slide.title && (
													<div
														className="font10 text-bold"
														style={{
															display: 'flex',
															alignItems: 'baseline',
															marginBottom: 15,
															lineHeight: 1.3,
															color: 'black',
															fontWeight: 'bold',
														}}
													>
														{slide.title}
													</div>
												)}
												{slide.address ? (
													<div
														className="font10"
														style={{
															display: 'flex',
															alignItems: 'flex-start',
															marginBottom: 15,
															lineHeight: 1.3,
														}}
													>
														<img
															src={getIcons('Destination', props.operator)}
															alt=""
															style={{ marginRight: 5, width: props.iconwidth ? props.iconwidth : '15px' }}
														/>
														<div>{slide.address}</div>
													</div>
												) : null}
												{slide.phone ? (
													<div
														className="font10"
														style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 15 }}
													>
														{props.operator && props.operator.operator_name == "busnorte" ? <img
															src={getIcons('Telephone', props.operator)}
															alt=""
															style={{ marginRight: 5, width: props.iconwidth ? props.iconwidth : '15px' }}
														/> : <img
															src={getIcons('TelephoneIcon', props.operator)}
															alt=""
															style={{ marginRight: 5, width: props.iconwidth ? props.iconwidth : '15px' }}
														/>}

														<div>{slide.phone}</div>
													</div>
												) : null}

												{slide.timing ? (
													<div
														className="font10"
														style={{
															display: 'flex',
															alignItems: 'flex-start',
															marginBottom: 15,
															lineHeight: 1.3,
														}}
													>
														<img
															src={getIcons('ClockIcon', props.operator)}
															alt=""
															style={{ width: 15, marginRight: 5, marginTop: 3 }}
														/>
														<div>{slide.timing}</div>
													</div>
												) : null}

												{slide.extra && (
													<div
														className="font10"
														style={{
															display: 'flex',
															alignItems: 'flex-start',
															marginBottom: 15,
															marginLeft: '20px',
														}}
													>
														<span>Sábados: {slide.extra}</span>
													</div>
												)}
											</div>
											<div className="font11" style={{ display: 'flex', alignItems: 'baseline', }}>
												{props.operator && props.operator.operator_name == "busnorte" ? <img
													src={getIcons('Vermapa', props.operator)}
													alt=""
													style={{ height: 10, width: 10, marginRight: 5 }}
												/> : <img
													src={getIcons('BlueArrow', props.operator)}
													alt=""
													style={{ height: 10, width: 10, marginRight: 5 }}
												/>}

												<a
													href={slide.mapLink}
													target="_blank"
													style={{ textDecoration: 'underline', color: props.vermapacolour ? props.vermapacolour : '#2E3191' }}
												>
													Ver mapa
												</a>
											</div>
										</div>
									)}
								</div>
							);
						})}
					{/* <div>Item 1</div>
        <div>Item 2</div>
        <div>Item 3</div>
        <div>Item 4</div> */}
				</Carousel>
			</div>
		</div>
	);
};

export default MultiSlider3;




// WEBPACK FOOTER //
// ./src/features/themes/common/MultiSlider/MultiSlider3.js